import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFantasyLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 1037,
	height: 167,
	viewBox: "0 0 1037 167",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3229_2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.25 164.6V3.31982H115.76V31.5398H35.12V76.1298H107.22L111.02 104.35H35.12V164.59H0.25V164.6Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M245.109 166.74L232.059 132.11H160.189L148.099 164.61H112.289L176.329 4.03L217.369 0L279.739 162.46L245.109 166.73V166.74ZM170.879 103.88H221.629L196.489 36.05L170.879 103.88Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M325.97 55.4999V164.6H294.42V3.31994H328.57L408.5 110.76V5.21994L440.05 1.18994V164.6H406.13L325.97 55.4999Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M506.51 164.6V31.5398H455.75V3.31982H591.89L587.86 31.5398H541.14V164.6H506.51Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M705.711 166.74L692.661 132.11H620.791L608.691 164.61H572.881L636.921 4.03L677.951 0L740.331 162.46L705.701 166.73H705.711V166.74ZM631.471 103.88H682.231L657.091 36.05L631.471 103.88Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M750.27 123.57C758.17 128.47 767.23 132.23 777.43 134.84C787.63 137.45 797.08 138.75 805.77 138.75C826.8 138.75 837.31 132.75 837.31 120.72C837.31 116.93 835.73 113.57 832.57 110.64C829.41 107.72 825.339 105.3 820.359 103.4C815.379 101.51 809.8 99.6099 803.64 97.7099C797.47 95.8199 791.35 93.5199 785.26 90.8299C779.17 88.1399 773.64 85.0599 768.65 81.5799C763.67 78.1099 759.6 73.3999 756.44 67.4699C753.27 61.5399 751.7 54.6999 751.7 46.9499C751.7 31.4499 757.19 19.9099 768.19 12.3199C779.17 4.72994 793.05 0.939941 809.81 0.939941C828.79 0.939941 848.549 5.12994 869.099 13.5099L865.31 44.1099C847.12 34.1499 830.209 29.1699 814.549 29.1699C805.849 29.1699 799.1 30.2799 794.27 32.4899C789.45 34.7099 787.039 38.9799 787.039 45.2999C787.039 50.1999 790 54.3199 795.93 57.6299C801.86 60.9499 809.01 63.8399 817.4 66.2899C825.78 68.7499 834.159 71.6699 842.539 75.0699C850.919 78.4699 858.08 83.7299 864.01 90.8399C869.94 97.9599 872.9 106.82 872.9 117.41C872.9 134.33 866.89 146.82 854.87 154.89C842.85 162.95 828.07 166.99 810.52 166.99C788.06 166.99 767.98 162.8 750.28 154.42V123.57H750.27Z",
				fill: "#A4FF01"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M974.971 114.31V164.59H940.111V113.84L881.051 5.21018L915.911 1.18018L958.371 81.3402L999.871 3.32018H1036.63L974.961 114.32L974.971 114.31Z",
				fill: "#A4FF01"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3229_2",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 1037,
			height: 167,
			fill: "white"
		})
	}) })]
});
export default SvgFantasyLogo;
